<h3 class="color-primary" mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
	{{data.description}}
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{'Cancel' | translate}}</button>
	<button mat-raised-button (click)="onYesClick()" cdkFocusInitial [disabled]="viewLoading">{{'Delete' |
		translate}}</button>
</div>